import React, { Children, cloneElement, FC, HTMLAttributes, ReactElement } from "react";
import classNames from "classnames";

const ButtonGroup = (props) => {
  const {
    borderWidth,
    children,
    className,
    color,
    colorIntensity,
    isVertical = false,
    rounded,
    size,
    variant,
    ...rest
  } = props;

  const classes = classNames("flex flex-wrap", { "flex-col": isVertical });

  const childClasses = classNames({
    /**
     * For Horizontal
     */
    "ltr:[&:not(:last-child)]:!rounded-r-none": !isVertical,
    "rtl:[&:not(:last-child)]:!rounded-l-none": !isVertical,
    "ltr:[&:not(:first-child)]:!rounded-l-none": !isVertical,
    "rtl:[&:not(:first-child)]:!rounded-r-none": !isVertical,
    /**
     * For Vertical
     */
    "[&:not(:last-child)]:!rounded-b-none": isVertical,
    "[&:not(:first-child)]:!rounded-t-none": isVertical,
  });

  return (
    <div data-component-name="ButtonGroup" className={classNames(classes, className)} {...rest}>
      {Children?.map(children, (child) =>
        cloneElement(child, {
          className: classNames(childClasses, child.props.className),
          borderWidth: borderWidth || child.props.borderWidth,
          color: color || child.props.color,
          colorIntensity: colorIntensity || child.props.colorIntensity,
          rounded: rounded || child.props.rounded,
          size: size || child.props.size,
          variant: variant || child.props.variant,
        })
      )}
    </div>
  );
};
ButtonGroup.displayName = "ButtonGroup";

export default ButtonGroup;
